












































import VueOptions from '@utils/VueOptions'

settings =
  name: 'OrganizerResourceListItem'

  vue:
    props: ['item', 'rowSize', 'actions', 'selected', 'backgroundColor']

    computed:
      verifiedBadgeSrc: -> "#{process.env.VUE_APP_IMAGE_ENDPOINT}/indicators/recess_verified_badge.png"

    methods:
      shouldExpandCollumn: (size) ->
        return true if @rowSize >= 2 && size == 'MEDIUM'
        return true if @rowSize == 3 && size == 'LARGE'

export default VueOptions.vue settings
